import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import Requests from "../../pages/services/Requests";
import Header from "../header";
import SidebarNav from "../sidebar";

const PastAppointments = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
    total: 0,
  });

  const columns = [
    {
      title: "#",
      dataIndex: "id",
      render: (text, record) => record.appointment.id,
      sorter: (a, b) => a.appointment.id - b.appointment.id,
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => record.appointment.client?.name || 'N/A',
      sorter: (a, b) => a.appointment.client.name.localeCompare(b.appointment.client.name),
    },
    {
      title: "Service",
      dataIndex: "service",
      render: (text, record) => record.appointment.service,
      sorter: (a, b) => a.appointment.service.localeCompare(b.appointment.service),
    },
    {
      title: "Phone",
      dataIndex: "phone",
      render: (text, record) => record.appointment.client?.phone || 'N/A',
      sorter: (a, b) => (a.appointment.client?.phone || '').localeCompare(b.appointment.client?.phone || ''),
    },
    {
      title: "Email",
      dataIndex: "email",
      render: (text, record) => record.appointment.client?.email || 'N/A',
      sorter: (a, b) => (a.appointment.client?.email || '').localeCompare(b.appointment.client?.email || ''),
    },
    {
      title: "Appointment Date",
      dataIndex: "time",
      render: (text, record) => (
        <>
          <div>{record.formatted_date}</div>
          <div className="text-muted small">{record.time}</div>
        </>
      ),
      sorter: (a, b) => new Date(a.appointment.date) - new Date(b.appointment.date),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: () => (
        <span className="badge badge-success">Completed</span>
      ),
    },
  ];

  const fetchData = async (page = 1, pageSize = 15) => {
    try {
      setLoading(true);
      const response = await Requests.getPastAppointments({
        page,
        per_page: pageSize
      });

      if (response.data.success) {
        setData(response.data.data);
        setPagination({
          current: response.data.pagination.current_page,
          pageSize: response.data.pagination.per_page,
          total: response.data.pagination.total,
        });
      }
    } catch (error) {
      console.error("Error fetching appointments:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleTableChange = (pagination) => {
    fetchData(pagination.current, pagination.pageSize);
  };

  return (
    <>
      <Header />
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-7 col-auto">
                <h3 className="page-title">Past Appointments</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Past Appointments</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="card-body p-0">
            <div className="table-responsive">
              <Table
                columns={columns}
                dataSource={data}
                rowKey={record => record.appointment.id}
                pagination={{
                  ...pagination,
                  pageSize: 15,
                  showSizeChanger: false,
                  showTotal: (total, range) =>
                    `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                }}
                loading={loading}
                onChange={handleTableChange}
                style={{ overflowX: "auto" }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PastAppointments;